import HeaderGlobalDashboard from './HeaderGlobalDashboard';

export default HeaderGlobalDashboard;
